import React from 'react';
import { match } from 'ts-pattern';
import TablerIconDoc from '~icons/tabler/file-type-doc';
import TablerLayoutList from '~icons/tabler/layout-list';
import ChatMessagePartToolContainer from './chat-message-part-tool-container';
import type { ChatMessagePartToolBaseProps } from './types';

export type ChatMessagePartToolDocSearchJoggrProps =
  ChatMessagePartToolBaseProps<'doc-search-joggr'>;

function ChatMessagePartToolDocSearchJoggr({
  toolInvocation,
  card,
  compact,
  defaultOpen,
  onEngage,
}: ChatMessagePartToolDocSearchJoggrProps) {
  return match(toolInvocation)
    .with(
      { state: 'result', result: { status: 'success' } },
      ({ result: { result } }) => (
        <ChatMessagePartToolContainer
          icon={<TablerLayoutList />}
          card={card}
          compact={compact}
          defaultOpen={defaultOpen}
          title={`Listed ${result?.length ?? 0} Joggr Docs`}
          status='result'
          items={
            result?.map((doc) => ({
              icon: <TablerIconDoc />,
              title: doc.title,
              to: `/app/documents/${doc.id}`,
              onClick: () => onEngage?.('engage'),
            })) ?? []
          }
          onToggle={() => {
            onEngage?.('engage');
          }}
        />
      )
    )
    .with({ state: 'result', result: { status: 'error' } }, () => null)
    .otherwise(() => {
      return (
        <ChatMessagePartToolContainer
          icon={<TablerLayoutList />}
          card={card}
          compact={compact}
          defaultOpen={defaultOpen}
          title='Searching Joggr Docs...'
          status='loading'
        />
      );
    });
}

export default React.memo(ChatMessagePartToolDocSearchJoggr);
